import React from 'react';
import { HealthFlexLogo } from '../../../assets/img';
import { StyledLoopTopLeftEdgeContainer, StyledLoopTopLeftLogo, StyledLoopTopLeftLogoContainer } from './styles';

interface ILoopTopLeftLogoProps {
    onClick?: () => void;
}

const LoopTopLeftLogo: React.FC<ILoopTopLeftLogoProps> = ({ onClick }) => {
    return (
        <StyledLoopTopLeftLogoContainer key="loop-top-left-logo">
            <StyledLoopTopLeftEdgeContainer />
            <StyledLoopTopLeftLogo src={HealthFlexLogo} layoutId="loop-logo" $clickable={!!onClick} onClick={onClick} />
        </StyledLoopTopLeftLogoContainer>
    );
};

export default LoopTopLeftLogo;
